import './widgetChart.scss'
import { useEffect, useLayoutEffect, useState } from 'react';
import Chart from "react-apexcharts";
import useWindowDimensions from '../../services/window-dimensions';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { TableWidget } from '../table-widget/TableWidget';
import format from 'date-fns/format';
import { addHours, subHours } from 'date-fns';
import { useTranslation } from 'react-i18next';

type Props = {
  title: string,
  data: any,
  type: any,
  isDate?: boolean,
  signal?: boolean,
  dataPointClick?: any,
  customHeight?: any,
  icon?: string
};

export const WidgetChart = (props: Props) => {
  const [chartData, setChartData] = useState<any>()
  const { t } = useTranslation();
  const { height, width } = useWindowDimensions();
  const [showModal, setShowModal] = useState(false);
  const { operatorId } = useParams();
  const toggleModal = () => {
    setShowModal(!showModal);
  }
  const { deviceId } = useParams();
  const [appsInstalledUrl, setAppsInstalledUrl] = useState<any>();
  const [showGraphModal, setShowGraphModal] = useState(false);
  const [selectedThreatGraph, setSelectedThreatGraph] = useState<any>();

  const toggleGraphModal = () => {
    setShowGraphModal(!showGraphModal);
  }

  useEffect(() => {
    if (!props.data) return;
    if (props.type !== 'donut') {
      buildLineChartData();
    } else {
      buildDonutChartData();
    }
  }, [props.data]);

  function buildLineChartData() {
    const categories: any[] = [];
    const data: any[] = [];
    if (props.signal) {
      props.data.forEach((item: any) => {
        item[1] = -(item[1]);
      });
    }

    props.data.forEach((item: any) => {
      if (item.type) {
        categories.push(item.type);
        data.push(item.count);
      } else {
        categories.push(item[0]);
        data.push(item[1]);
      }
    });

    const chartInfo: any = {
      options: {
        chart: {
          id: props.title,
          toolbar: {
            show: false,
            tools: {
              zoom: false,
              //selection: true,
            }
          },
        },
        xaxis: { categories },
        yaxis: { labels: { formatter: (val: any) => '-' + val } }
      },
      series: [{ name: 'series-1', data }]
    };

    if (props.isDate) {
      chartInfo.options.xaxis.type = 'datetime';
      chartInfo.options.xaxis.labels = {
        format: 'dd/MM',
      }
    }

    if (props.dataPointClick) {
      chartInfo.options.chart.events = addDataPointSelectionEvent();
    }
    if (props.signal) {
      chartInfo.options.chart.events = addClickEventToChart();
    }

    if (props.type === 'bar') {
      chartInfo.options.plotOptions = {
        bar: {
          borderRadius: 4,
          horizontal: true
        }
      };
    }

    if (props.type === 'line') {
      chartInfo.options.markers = {
        size: 5
      };
      chartInfo.options.stroke = {
        width: 4
      }
    }

    setChartData(chartInfo);
  }

  function addClickEventToChart() {
    return {
      markerClick: async (event: any, chartContext: any, config: any) => {
        if (config.dataPointIndex !== undefined) {
          setAppsInstalledUrl(`${props.data[config.dataPointIndex][0]}`);
          toggleModal();
        }
      }
    }
  }

  function addDataPointSelectionEvent() {
    return {
      dataPointSelection: (event: any, chartContext: any, config: any) => {
        setSelectedThreatGraph(chartContext.w.globals.labels[config.dataPointIndex])
        toggleGraphModal();
      },
    }
  }

  function buildDonutChartData() {
    const filtered = props.data.filter((item: any) => !!item.type);
    const options = { labels: filtered.map((item: any) => item.type) };
    const series = filtered.map((item: any) => item.count);

    setChartData({ options, series });
  }

  function convertDate(date: string) {
    const fromDate = subHours(new Date(date), 48);
    const toDate = addHours(new Date(date), 48);
    return t('widgets.chart.appsInstalledRange', { from: format(fromDate, 'dd/MM/yyyy HH:mm:ss'), to: format(toDate, 'dd/MM/yyyy HH:mm:ss') });
  }

  return (
    <section className={'widget-chart rounded-xl'} >
      <header>
        {props.icon && <img className='title-icon' src={props.icon}></img>}
        <span className='bold'>{props.title}</span>
      </header>

      {chartData && props.type !== 'donut' && <div className={props.type === 'line' ? 'line-chart' : ''}>
        <Chart
          options={chartData.options}
          series={chartData.series}
          type={props.type}
          height={props.customHeight}
        />
      </div>}


      {chartData && props.type === 'donut' && <div className='routines-chart'>
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="donut"
          height={props.customHeight}
        />
      </div>}

      <Modal show={showModal} onHide={toggleModal} dialogClassName="apps-installed" centered>
        <Modal.Header closeButton>
          <Modal.Title>{appsInstalledUrl ? convertDate(appsInstalledUrl) : t('widgets.chart.appsInstalled')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TableWidget hideDates={true} defaultDate={'30d'} url={`op/${deviceId}/deviceApps/signal/${appsInstalledUrl}`} countPerPage={10} title={t('widgets.chart.appsInstalled')} icon='/icons/pc-grey.svg' />
        </Modal.Body>
      </Modal>

      <Modal show={showGraphModal} onHide={toggleGraphModal} dialogClassName="table-modal-retina">
        <Modal.Header closeButton>
          <Modal.Title>{t('widgets.chart.graphData')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TableWidget hideDates={true} defaultDate={'60d'} url={`op/${operatorId}/threats/${selectedThreatGraph}`} countPerPage={10} title={selectedThreatGraph} icon='/icons/pc-grey.svg' />
        </Modal.Body>
      </Modal>
    </section>
  )
}
